import { oz } from '@weft/utils';
import { ApiDateSchema, CurrencySchema } from '../../../primitives';
import { ContractStatusSchema } from '../../contract';

export const ContractsReportSchmea = oz.array(oz.object({
  contractName: oz.string(),
  customerName: oz.string(),
  status: ContractStatusSchema,
  startDate: ApiDateSchema,
  endDate: ApiDateSchema.optional(),
  currency: CurrencySchema,
  discountAmount: oz.number(),
  daysToEnd: oz.number().optional(),
  trialPeriod: oz.string().optional(),
  overageAmount: oz.number(),
  autoRenewal: oz.boolean(),
  estimatedAmount: oz.number(),
  syncStatusUpdatedAt: ApiDateSchema.optional(),
}));

export type ContractsReport = oz.infer<typeof ContractsReportSchmea>;